import { render } from "./AppSubmenu.vue?vue&type=template&id=fd924ea8&scoped=true"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"

import "./AppSubmenu.vue?vue&type=style&index=0&id=fd924ea8&scoped=true&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd924ea8"]])

export default __exports__